import facetsToIndexJSON from "@/lib/prismicio/prismic-facets-to-index.json"
import robotstxtJSON from "@/lib/prismicio/prismic-robots-txt.json"
import { PrismicFacetsToIndexJson, PrismicRobotsTxtData, getRobotsMetaTagBase } from "@jog/shared"
import { useMemo } from "react"

export const useRobotsMetaTag = (path?: string) => {
    return useMemo(
        () =>
            typeof window !== "undefined"
                ? getRobotsMetaTagBase(
                      (facetsToIndexJSON as PrismicFacetsToIndexJson).facetsToIndex,
                      robotstxtJSON as PrismicRobotsTxtData["pagesToDisallow"]
                  )(path || window.location.pathname)
                : "",
        [path]
    )
}
